export const MAX_CLIENT_GROUP_AGENTS = 4;
export const MAX_CLIENT_GROUP_CLIENTS = 4;

export const BUYER_TYPES = [
  { value: 'individual', label: 'Individual' },
  { value: 'trust', label: 'Trust' },
  { value: 'entity', label: 'Entity (LLC, Corp, Other)' },
  { value: 'probate', label: 'Probate/Court Administration' },
  { value: 'powerOfAttorney', label: 'Power of Attorney' },
];

export const TRUST_OPTIONS = [
  { label: 'Successor Trustee', value: 'successorTrustee' },
  { label: 'Trustee', value: 'trustee' },
  { label: 'Other', value: 'other' },
];

export const TRUST_OPTIONS_NO_SUCCESSOR = [
  { label: 'Trustee', value: 'trustee' },
  { label: 'Other', value: 'other' },
];

export const ENTITY_OPTIONS = [
  { label: 'CEO', value: 'ceo' },
  { label: 'Partner', value: 'partner' },
  { label: 'Managing Partner', value: 'managingPartner' },
  { label: 'Other', value: 'other' },
];

// WA cover sheet "Ownership Status" (buyer)
export const OWNERSHIP_STATUS_OPTIONS = [
  'A Limited Liability partnership',
  'A limited liability company',
  'A general partnership',
  'A limited partnership',
  'A corporation',
  'Unmarried person',
  'An unmarried person',
  'Married as separate property',
  'A married couple',
  'Domestic partners',
].map((value) => ({ value, label: value }));

export const PROBATE_OPTIONS = [
  { label: 'Administrator', value: 'administrator' },
  { label: 'Executor', value: 'executor' },
  { label: 'Conservator', value: 'conservator' },
  { label: 'Other', value: 'other' },
];
